module.exports = __webpack_public_path__ + "static/resources-menu-91aa995d1275b7c43c3e1dfd31e3abbf.png";